<template>
  <div class="row">
    <div class="col-lg-12 col-md-12">
      <card class="shadow-lg">
        <div class="row content-add-btn">
          <button class="btn btn-secondary" @click="$router.go(-1)">
            <em class="fa fa-chevron-left"></em>
            {{ $t('common_words.exit') }}
          </button>
        </div>
        <hr />
        <form-wizard
          ref="formWizard"
          v-if="this.isCreate() || this.isUpdate()"
          @on-complete="addSowingForm"
          title
          subtitle
          :back-button-text="$t('common_words.back')"
          :next-button-text="$t('common_words.next')"
          :finish-button-text="$t('common_words.save')"
          class="custom-padding-wz-header"
        >
          <tab-content
            :title="$t('common_words.general_information')"
            :before-change="() => validateStep('firstStep')"
          >
            <first-step
              ref="firstStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></first-step>
          </tab-content>
          <tab-content
            :title="$t('common_words.ubication')"
            :before-change="() => validateStep('secondStep')"
          >
            <second-step
              ref="secondStep"
              @on-validated="onStepValidated"
              @showHideLoading="showHideLoading"
            ></second-step>
          </tab-content>
          <tab-content :title="$t('common_words.confirm')">
            <p class="cm-mg-p-wzd text-center text-muted">
              3. {{ $t('common_words.verify_inputed_information') }}
            </p>
            <br />
            <div class="row d-flex justify-content-center">
              <div class="col-9">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.code') }}:</strong>
                        </h6>
                        {{ sowingForm.code }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.name') }}:</strong>
                        </h6>
                        {{ sowingForm.name }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('sowing.sowing_method') }}:</strong>
                        </h6>
                        {{ sowingForm.type }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('sowing.sowing_type') }}:</strong>
                        </h6>
                        {{ sowingForm.sowing_type }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('sowing.seed_type') }}:</strong>
                        </h6>
                        {{ sowingForm.seedTypeName }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.distance') }}:</strong>
                        </h6>
                        {{
                          sowingForm.distance
                            ? sowingForm.distance
                            : $t('common_words.no_assigned')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('climate.temperature') }}:</strong>
                        </h6>
                        {{
                          sowingForm.temperature
                            ? sowingForm.temperature
                            : $t('common_words.no_assigned')
                        }}
                      </td>
                    </tr>
                    <tr class="shadow-sm">
                      <td>
                        <h6 class="mb-2">
                          <strong>{{ $t('common_words.description') }}:</strong>
                        </h6>
                        {{
                          sowingForm.description
                            ? sowingForm.description
                            : $t('common_words.no_assigned')
                        }}
                      </td>
                    </tr>
                    <td>
                      <h6 class="mb-2">
                        <strong>{{ $t('common_words.companies2') }}:</strong>
                      </h6>
                      <span
                        v-for="(_, index) in sowingForm.businesses_names"
                        :key="index"
                      >
                        <el-tag type="info">
                          {{ sowingForm.businesses_names[index] }}
                        </el-tag>
                      </span>
                    </td>
                  </tbody>
                </table>
              </div>
            </div>
          </tab-content>
        </form-wizard>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions_operations') }}
          </h5>
        </div>
      </card>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { showContinue } from 'src/util/Util.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinPermissions from 'src/util/mixinPermissions';
import FirstStep from './steps/FirstStep.vue';
import SecondStep from './steps/SecondStep.vue';

export default {
  components: {
    FirstStep,
    SecondStep,
  },
  data() {
    return {
      sowingForm: {
        name: null,
        code: null,
        type: null,
        sowing_type: null,
        seed_type_id: [],
        distance: null,
        temperature: null,
        description: null,
        seedType: null,
        businesses_id: [],
        businesses_names: [],
        seedTypeName: [],
      },
    };
  },
  mixins: [MixinPermissions, mixinMasters, MixinMenu],

  methods: {
    cleanAllSteps() {
      this.$refs.firstStep.model = { ...this.$refs.firstStep.initialModel };
      this.$refs.secondStep.model = { ...this.$refs.secondStep.initialModel };
    },

    updateInSecondStep(editForm) {
      this.$refs.secondStep.loadToUpdate(editForm);
    },

    validateStep(ref) {
      return this.$refs[ref].validate();
    },

    onStepValidated(model) {
      this.sowingForm = { ...this.sowingForm, ...model };
    },

    addSowingForm() {
      this.showHideLoading(true);
      this.sowingForm.route = 'seeding/sowingmethods';
      if (sessionStorage.getItem('editForm')) {
        if (this.isUpdate()) {
          this.sowingForm.id = JSON.parse(
            sessionStorage.getItem('editForm')
          ).id;
          Axios.updateMaster(this.sowingForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/seeding/sowingmethods',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      } else {
        if (this.isCreate()) {
          Axios.saveMaster(this.sowingForm)
            .then((response) => {
              this.showHideLoading();
              showContinue(
                this,
                response.data.message ? response.data.message : response.errors,
                '/seeding/sowingmethods',
                null
              );
            })
            .catch((error) => this.showMessageErrors(error));
        } else {
          this.showMessageAccess();
          this.showHideLoading();
        }
      }
    },
  },

  mounted() {
    this.selectedItemOnMenu('seeding/sowingmethods');
  },

  beforeDestroy() {
    sessionStorage.removeItem('editForm');
    sessionStorage.removeItem('tableCode');
    this.deselectedItemOnMenu('seeding/sowingmethods');
  },
};
</script>

<style>
.vue-form-wizard .wizard-icon-circle .wizard-icon-container {
  border-radius: 100% !important;
}
</style>
